import { trpc as Common } from '@tencent/tpro_rmonitor_web_server_common';
import { CSSProperties } from 'react';
import { WithTypeCast } from '@raft/utils';

export type PropsWithStyles<T> = T & {
  style?: CSSProperties;
  className?: string;
};

export type IssueType = WithTypeCast<Common.rmonitor.web_server.IssueType>;
export type IssueMetricType = WithTypeCast<Common.rmonitor.web_server.IssueMetricType>;
export const { IssueType } = Common.rmonitor.web_server;
export const { IssueMetricType } = Common.rmonitor.web_server;
